import { lazy, Suspense } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// Lazy load components with prefetch hints
const HeroSection = lazy(() => import(/* webpackPrefetch: true */ './components/HeroSection'));
const ProductsSection = lazy(() => import(/* webpackPrefetch: true */ './components/ProductsSection'));
const ClientsSection = lazy(() => import(/* webpackPrefetch: true */ './components/ClientsSection'));
const CasesSection = lazy(() => import(/* webpackPrefetch: true */ './components/CasesSection'));
const ContactSection = lazy(() => import(/* webpackPrefetch: true */ './components/ContactSection'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="min-h-[400px] flex items-center justify-center bg-gray-50">
    <div className="loading-spinner"></div>
  </div>
);

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header startInDarkMode={true} />

      <Suspense fallback={<LoadingFallback />}>
        <HeroSection />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <ProductsSection />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <ClientsSection />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <CasesSection />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <ContactSection />
      </Suspense>

      <Footer />
    </div>
  );
};

export default HomePage;
